export function showForSR() {
  return `
    display: inline-block;
    width: 1px;
    height: 1px;
    padding: 0;
    overflow: hidden;
    clip: rect(0,0,0,0);
    white-space: nowrap;
    border: 0; 
  `;
}
